module.exports = __webpack_public_path__ + "img/custom-betta.625e5445.jpg";